var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("detailsText"),
        visible: _vm.dialogTableVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogTableVisible = $event
        },
      },
    },
    [
      _c("b", [
        _vm._v(
          _vm._s(_vm.$t("goodsSku.detail.qty")) +
            " : " +
            _vm._s((_vm.gridData[0] && _vm.gridData[0].qty) || 0)
        ),
      ]),
      _c("br"),
      _c("br"),
      _c(
        "el-table",
        { attrs: { border: "", script: "", data: _vm.gridData } },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "length",
              label: _vm.$t("goodsSku.detail.length"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "width",
              label: _vm.$t("goodsSku.detail.width"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "height",
              label: _vm.$t("goodsSku.detail.height"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "weight",
              label: _vm.$t("goodsSku.detail.weight"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("goodsSku.detail.UnitVolume"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (scope.row.width *
                            scope.row.height *
                            scope.row.length) /
                            1000000
                        ) + "m³"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "qty",
              label: _vm.$t("goodsSku.detail.itemPerCarton"),
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { "margin-bottom": "20px" },
          attrs: { border: "", script: "", data: _vm.gridData },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "cartonLength",
              label: _vm.$t("goodsSku.detail.cartonLength"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "cartonWidth",
              label: _vm.$t("goodsSku.detail.cartonWidth"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "cartonHeight",
              label: _vm.$t("goodsSku.detail.cartonHeight"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "cartonWeight",
              label: _vm.$t("goodsSku.detail.cartonWeight"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("goodsSku.detail.cartonVolume"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (scope.row.cartonWidth *
                            scope.row.cartonHeight *
                            scope.row.cartonLength) /
                            1000000
                        ) + "m³"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "usableNum",
              label: _vm.$t("goodsSku.detail.stockQty"),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }